import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { B as a } from "../Button-DQ5ID5KN.js";
import { P as y } from "../Profile-BFmE5iar.js";
import { P as f } from "../PerformanceIndicator-D0VbGhZS.js";
import { T as i } from "../Table-Cj-wDn-T.js";
const m = "320px", g = "600px", u = "1025px", b = "_isVisuallyHidden_llfaq_51", p = "_tips_llfaq_63", H = "_tipsTable_llfaq_63", C = "_button_llfaq_63", S = "_tableHeadings_llfaq_66", W = "_indicator_llfaq_82", t = {
  mobile: m,
  "mobile-wide": "480px",
  tablet: g,
  "tablet-wide": "800px",
  desktop: u,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: b,
  tips: p,
  tipsTable: H,
  button: C,
  tableHeadings: S,
  indicator: W
}, T = ({
  updateDate: s,
  tipsterHitRate: c,
  tipsterImage: x,
  tipsterName: d,
  tipsterSubline: r,
  stats: n,
  profileLink: h,
  tipLink: o
}) => /* @__PURE__ */ e(i.Group, { className: t.tips, children: /* @__PURE__ */ l(i, { label: "EV", mobileColumns: 3, className: t.tipsTable, children: [
  /* @__PURE__ */ l(i.Caption, { children: [
    "Updated ",
    s
  ] }),
  /* @__PURE__ */ e(i.Head, { children: /* @__PURE__ */ e(i.Row, { children: /* @__PURE__ */ e(i.Column, { mobileView: "hide", children: "Last 10 Selections" }) }) }),
  /* @__PURE__ */ e(i.Head, { className: t.tableHeadings, children: /* @__PURE__ */ l(i.Row, { children: [
    /* @__PURE__ */ e(i.Column, { justifyContent: "center", showDividers: !0, children: "YTD P/L" }),
    /* @__PURE__ */ e(i.Column, { justifyContent: "center", showDividers: !0, children: "Lifetime P/L" }),
    /* @__PURE__ */ e(i.Column, { justifyContent: "center", showDividers: !0, children: "ROI" }),
    /* @__PURE__ */ e(i.Column, { justifyContent: "center", mobileView: "hide", children: "Active Tips" })
  ] }) }),
  /* @__PURE__ */ e(i.Body, { isAdditionalContent: !0, children: /* @__PURE__ */ e(i.Row, { children: /* @__PURE__ */ e(i.Cell, { children: /* @__PURE__ */ e(
    y,
    {
      name: d,
      image: x,
      description: r,
      profileLink: {
        href: h,
        text: "See Profile"
      }
    }
  ) }) }) }),
  /* @__PURE__ */ e(i.Body, { isAdditionalContent: !0, children: /* @__PURE__ */ e(i.Row, { children: /* @__PURE__ */ e(i.Cell, { children: /* @__PURE__ */ e(
    f,
    {
      history: c.slice(0, 10),
      showHitRate: !1,
      position: "start",
      label: "Last 10 Selections",
      spacing: "s",
      hasMaxWidth: !1,
      className: t.indicator
    }
  ) }) }) }),
  /* @__PURE__ */ e(i.Body, { children: /* @__PURE__ */ l(i.Row, { children: [
    /* @__PURE__ */ e(i.Cell, { justifyContent: "center", showDividers: !0, children: n.year }),
    /* @__PURE__ */ e(i.Cell, { justifyContent: "center", showDividers: !0, children: n.lifetime }),
    /* @__PURE__ */ e(i.Cell, { justifyContent: "center", showDividers: !0, children: n.roi }),
    /* @__PURE__ */ e(i.Cell, { isFullWidthMobile: !0, children: /* @__PURE__ */ e(a, { className: t.button, isFullWidth: !0, asChild: !0, children: /* @__PURE__ */ e("a", { href: o.href, children: o.text }) }) })
  ] }) })
] }) });
export {
  T as Tipster
};
